<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Указания по ведению журнала
    </div>

    <p>
      1. Под началом выдерживания бетона принимается время пуска теплоносителя при искусственном обогреве бетона, либо
      время окончания бетонирования конструкции при методе «термоса».
    </p>
    <p>
      2. Прекращение пуска теплоносителя, распалубливание конструкции отмечается в журнале условными обозначениями.
    </p>
    <p>
      3. По окончании ведения журнала он сдается в производственно-технический отдел, который делает отметку о приемке
      в табл. 4 общего журнала работ.
    </p>
    <n-items v-if="project">
      <n-input title="Представитель технического надзора" value="" />
      <n-input title="Представитель авторского надзора" value="" />
      <n-input title="Начальник участка (ст. прораб)" value="" />
      <n-input title="Начальник производственно-технического отдела" value="" />
      <!--      <n-button @click="submit" color="success">Сохранить</n-button>-->
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter4',
  props: [ 'project', 'journal', ],
  data: () => ({
    data: [],
  }),
  computed: {
    columns() {
      if (!this.journal?.front) {
        return []
      } else {
        return [
          ...this.journal.front.index[2].content,
          { name: 'tools', title: '', },
        ]
      }
    },
    createRecordLink() {
      return { query: { ...this.$route.query, 'new-record': null, }, }
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journalsOld.records.get(this.project.id, this.$route.params.journal, 'records').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    &::v-deep {
      .n-table .row.header .cell {
        min-width: 100px;
      }
    }
  }
</style>
